import { initPage } from './init';

const filters = [];

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener(
    'popstate',
    function (event) {
      if (history.state && history.state.id === 'filter') {
        location.reload();
      }
    },
    false
  );

  function devLog(msg) {
    // console.log(msg);
  }

  function filterLoadUrl(id, url, reload = true) {
    devLog('filterLoadUrl', id, url, reload);
    document
      .querySelector('.filter-results[data-id="' + id + '"]')
      .classList.add('is-loading');

    let loadUrl = url;
    if (!reload) {
      if (url.indexOf('?') !== -1) loadUrl += '&loadmore=1';
      else loadUrl += '?loadmore=1';
    }

    fetch(loadUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // push state
        if (filters[id].updateUrl) {
          const title = doc.querySelector('title').textContent;
          window.history.pushState(
            {
              id: 'filter',
            },
            title,
            url
          );
        }

        if (reload) {
          // replace results content
          document.querySelector(
            '.filter-results[data-id="' + id + '"]'
          ).innerHTML = doc.querySelector(
            '.filter-results[data-id="' + id + '"]'
          ).innerHTML;

          // replace button filters: buttons
          document
            .querySelectorAll(
              '.filters[data-id="' +
                id +
                '"] [data-filter] button[data-filter-btn]'
            )
            .forEach((el) => {
              const filterId = el
                .closest('[data-filter]')
                .getAttribute('data-id');
              const elNew = doc.querySelector(
                '.filters[data-id="' +
                  id +
                  '"] [data-filter][data-id="' +
                  filterId +
                  '"] [data-filter-btn][data-value="' +
                  el.getAttribute('data-value') +
                  '"]'
              );
              let setDisabled = false;
              if (elNew && typeof elNew.disabled !== 'undefined')
                setDisabled = elNew.disabled;
              devLog('filterLoadUrl setDisabled', setDisabled);
              el.disabled = setDisabled;
            });

          // replace button filters: anchors
          document
            .querySelectorAll(
              '.filters[data-id="' + id + '"] [data-filter] a[data-filter-btn]'
            )
            .forEach((el) => {
              const filterId = el
                .closest('[data-filter]')
                .getAttribute('data-id');
              const elNew = doc.querySelector(
                '.filters[data-id="' +
                  id +
                  '"] [data-filter][data-id="' +
                  filterId +
                  '"] [data-filter-btn][data-value="' +
                  el.getAttribute('data-value') +
                  '"]'
              );
              let setDisabled = false;
              if (elNew && elNew.getAttribute('aria-disabled'))
                setDisabled = elNew.getAttribute('aria-disabled');
              el.setAttribute('aria-disabled', setDisabled);
            });
        } else {
          document.querySelector(
            '.filter-results[data-id="' + id + '"] .cards'
          ).innerHTML =
            document.querySelector(
              '.filter-results[data-id="' + id + '"] .cards'
            ).innerHTML +
            doc.querySelector('.filter-results[data-id="' + id + '"] .cards')
              .innerHTML;
          if (
            doc.querySelector(
              '.filter-results[data-id="' + id + '"] .load-more'
            )
          ) {
            document.querySelector(
              '.filter-results[data-id="' + id + '"] .load-more'
            ).innerHTML = doc.querySelector(
              '.filter-results[data-id="' + id + '"] .load-more'
            ).innerHTML;
          } else {
            document
              .querySelector('.filter-results[data-id="' + id + '"] .load-more')
              .remove();
          }
        }
        document
          .querySelector('.filter-results[data-id="' + id + '"]')
          .classList.remove('is-loading');

        // init filter
        filterInit(id);
        initPage();

        // activate block links
        document
          .querySelectorAll('.filter-results[data-id="' + id + '"] .block-link')
          .forEach((el) => {
            el.addEventListener('click', function (e) {
              el.querySelector('a').click();
            });
          });
      })
      .catch(function (err) {
        devLog('Failed to fetch page: ', err);
      });
  }

  function filterSearch(id, jumpToUrl = false) {
    const params = {};
    const query = {};
    let isFiltered = false;

    // loop through inputs to find values
    document
      .querySelectorAll(
        '.filters[data-id="' +
          id +
          '"] [data-filter], [data-filter][data-filter-id="' +
          id +
          '"]'
      )
      .forEach((el) => {
        if (el.querySelector('[data-filter-input]')) {
          const id = el.getAttribute('data-id');
          const type = el.getAttribute('data-type');
          const val = el.querySelector('[data-filter-input]').value;
          devLog('filterSearch', id, type, val);
          if (val) {
            isFiltered = true;
            if (type === 'query') {
              query[id] = val;
            } else {
              params[id] = val;
            }
          }
          el.classList.toggle('is-active', val);
        }
      });

    // make url
    const globalParamsOrder = [
      'category',
      'service',
      'topic',
      'location',
      'sector',
      'month',
      'page',
    ];
    let url = filters[id].rootUrl;
    let sep = '';
    globalParamsOrder.forEach((key) => {
      if (params[key] !== undefined && params[key] !== 'all') {
        // if (key == 'page') {
        url += sep + key;
        sep = '/';
        // }
        url += sep + params[key];
        sep = '/';
      }
    });
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        if (
          params[key] !== undefined &&
          params[key] !== 'all' &&
          globalParamsOrder.indexOf(key) === -1
        ) {
          url += sep + key;
          sep = '/';
          url += sep + params[key];
        }
      }
    }
    url += sep;

    // add query string
    sep = '';
    let urlQuery = '';
    for (const key in query) {
      if (Object.prototype.hasOwnProperty.call(query, key)) {
        if (query[key] !== undefined && query[key].length) {
          urlQuery += sep + key + '=' + encodeURIComponent(query[key]);
          sep = '&';
        }
      }
    }
    if (urlQuery.length) {
      if (filters[id].rootUrlHasQueryString) urlQuery = '&' + urlQuery;
      else urlQuery = '?' + urlQuery;
      url = url + urlQuery;
    }

    let newUrl = url.replace(window.location.host, '');
    newUrl = newUrl.replace(window.location.protocol, '');
    newUrl = newUrl.replace('//', '');
    const currentUrl = window.location.pathname + window.location.search;

    devLog('filterSearch url', newUrl, currentUrl);
    if (newUrl !== currentUrl) {
      if (jumpToUrl) {
        window.location.href = url;
      } else {
        devLog('filterSearch', id, url);
        filterLoadUrl(id, url);
      }
    }

    // search: update keywords
    if (query.keywords === undefined || query.keywords === '') {
      filterLoadUrl(id, url);
      document.querySelectorAll('[data-filter-title-display]').forEach((el) => {
        el.style.display = 'none';
      });
      document
        .querySelectorAll('[data-filter-title-nr-display]')
        .forEach((el) => {
          el.style.display = 'block';
        });
      document.querySelectorAll('[data-row-id="section"]').forEach((el) => {
        el.style.display = 'none';
      });
      document.querySelectorAll('[data-filter-nr-text]').forEach((el) => {
        el.style.display = 'none';
      });
    } else {
      document
        .querySelectorAll('[data-filter-keywords-display]')
        .forEach((el) => {
          el.innerHTML = query.keywords;
        });
      document.querySelectorAll('[data-filter-title-display]').forEach((el) => {
        el.style.display = 'block';
      });
      document
        .querySelectorAll('[data-filter-title-nr-display]')
        .forEach((el) => {
          el.style.display = 'none';
        });
      document.querySelectorAll('[data-row-id="section"]').forEach((el) => {
        el.style.display = 'block';
      });
      document.querySelectorAll('[data-filter-nr-text]').forEach((el) => {
        el.style.display = 'block';
      });
    }

    // show hide clear button
    const clearBtn = document.querySelector(
      '.filters[data-id="' + id + '"] [data-filter-clear]'
    );
    if (clearBtn) {
      if (isFiltered) {
        clearBtn.classList.remove('filter-btn--hidden');
      } else {
        clearBtn.classList.add('filter-btn--hidden');
      }
      // clearBtn.style.visibility = isFiltered ? 'visible' : 'hidden';
    }

    // scroll to the top of the results for the search filter
    if (id === 'search') {
      document
        .querySelector('.filters[data-id="' + id + '"]')
        .scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    return false;
  }

  function filterInit(id) {
    const filterLoadMore = document.querySelector(
      '.filter-results[data-id="' + id + '"] [data-action="filterLoadMore"]'
    );
    if (filterLoadMore) {
      filterLoadMore.addEventListener('click', function (event) {
        const url = filterLoadMore.getAttribute('href');
        filterLoadUrl(id, url, false);

        event.preventDefault();
      });
    }
  }

  document.querySelectorAll('.filters').forEach((el) => {
    const id = el.getAttribute('data-id');
    filters[id] = [];
    filters[id].rootUrl = el.getAttribute('data-rootUrl');
    filters[id].currentUrl = el.getAttribute('data-currentUrl');
    filters[id].updateUrl =
      el.getAttribute('data-updateUrl') === 'true' ?? false;
    filters[id].rootUrlHasQueryString =
      el.getAttribute('data-rootUrlHasQueryString') === 'true' ?? false;
    filterInit(id);
  });

  function filterClear(id) {
    document
      .querySelectorAll('.filters[data-id="' + id + '"] [data-filter-input]')
      .forEach((el) => {
        el.value = '';
      });
    document
      .querySelectorAll('.filters[data-id="' + id + '"] [data-filter-btn]')
      .forEach((el) => {
        el.classList.remove('btn--active');
      });
    filterSearch(id);
  }

  // filter keyword input delay
  function delay(callback, ms) {
    let timer = 0;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  document.querySelectorAll('[data-filter-btn]').forEach((el) => {
    el.addEventListener('click', function (event) {
      el.parentNode.querySelector('[data-filter-input]').value =
        el.getAttribute('data-value');
      document.querySelectorAll('[data-filter-btn]').forEach((btn) => {
        btn.classList.remove('btn--active');
      });
      el.classList.add('btn--active');
      const id =
        el.closest('[data-filter]').getAttribute('data-filter-id') ||
        el.closest('.filters').getAttribute('data-id');
      filterSearch(id);
      event.preventDefault();
    });
  });

  document.querySelectorAll('[data-filter-select]').forEach((el) => {
    el.addEventListener(
      'change',
      delay(function (event) {
        const id =
          el.closest('[data-filter]').getAttribute('data-filter-id') ||
          el.closest('.filters').getAttribute('data-id');
        filterSearch(id);
      }, 500)
    );
  });

  document.querySelectorAll('[data-filter-text]').forEach((el) => {
    el.addEventListener(
      'keydown',
      delay(function (event) {
        if (event.key !== 'Tab' && event.key !== 'Meta') {
          // const id = el.closest('.filters').getAttribute('data-id');
          const id =
            el.closest('[data-filter]').getAttribute('data-filter-id') ||
            el.closest('.filters').getAttribute('data-id');
          devLog('filterSearch', id);
          filterSearch(id);

          // record search terms
          devLog('Recording search term:', el.value);
          devLog(el.getAttribute('data-record-search'));
          if (el.getAttribute('data-record-search') === 'true') {
            fetch('/actions/site-module/search/record', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
              },
              body: JSON.stringify({ term: el.value }),
            });
          }
        }
      }, 500)
    );
  });

  document.querySelectorAll('[data-filter-clear]').forEach((el) => {
    el.addEventListener('click', function (event) {
      const id = el.closest('.filters').getAttribute('data-id');
      filterClear(id);
    });
  });

  if (window.innerWidth > 1000) {
    if (document.querySelector('.filters--with-toggle')) {
      document
        .querySelector('.filters--with-toggle')
        .setAttribute('aria-hidden', false);
    }
  }

  document
    .querySelectorAll('[aria-controls="filters"], [data-type="filterToggle"]')
    .forEach((el) => {
      el.addEventListener('click', function (event) {
        if (
          document.querySelector('#filters').getAttribute('aria-hidden') ===
          'true'
        ) {
          el.querySelector('.btn__text').innerHTML = 'Filter results';
        } else {
          el.querySelector('.btn__text').innerHTML = 'Hide filter';
        }
      });
    });

  devLog('filters initialized');
  devLog(filters);
});
